import { COMMON, COMPONENTS } from '../utils/constants.json';

const INITIAL_STATE = {
  snackBar: {},
};
/**
 * Reducer - to update services state
 * @param {Object} state initial/default services state.
 * @param {Object} action to be performed
 * @return {Object} new services state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case COMMON.RESOURCES.SUCCESS:
      return { ...state, ...payload };
    case COMMON.RESOURCES.FAILURE:
      return { ...state, ...payload };
    case COMMON.UPLOAD.SUCCESS:
      return { ...state, ...payload };
    case COMMON.UPLOAD.FAILURE:
      return { ...state, ...payload };
    case COMPONENTS.LOADER.HIDE:
      return { ...state, ...payload };
    case COMMON.CLEAR.LOGOUT_CLEAR:
      return { ...INITIAL_STATE };
    case COMMON.SNACKBAR.SHOW:
      return { ...state, snackBar: { ...payload } };
    default:
      return { ...state };
  }
}
